module.exports = __webpack_public_path__ + "static/media/meeting.0d96f4e0.svg";